export default "__VITE_ASSET__C3YU1Chx__"